import React, { useState, useEffect } from "react";
import api from "./api";
import { FaHistory } from "react-icons/fa";
import { DateTime } from "luxon";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

function BackfillPage() {
  const defaultDateFrom = DateTime.now().startOf("year").toISODate();
  const defaultDateTo = DateTime.now().toISODate();

  const [companies, setCompanies] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [dateFrom, setDateFrom] = useState(defaultDateFrom);
  const [dateTo, setDateTo] = useState(defaultDateTo);
  const [force, setForce] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    api
      .get("/api/listCompaniesFun")
      .then((res) => {
        setCompanies(res.data);
        if (res.data.length > 0) setCompanyName(res.data[0]);
      })
      .catch((err) => console.error("Failed to load companies:", err));
  }, []);

  const handleBackfill = async () => {
    if (!companyName) return;
    setLoading(true);
    setIsError(false);
    setMessage("Dopuna u toku... ovo moze potrajati.");
    try {
      const res = await api.post("/api/backloadCompanyFun", {
        companyName,
        dateFrom,
        dateTo,
        force,
      });
      setMessage(res.data.message || "Dopuna zavrsena.");
      setIsError(false);
    } catch (error) {
      setIsError(true);
      setMessage(
        error.response?.data?.message ||
          "Dopuna neuspesna ili je istekla. Pokusajte sa uzim periodom ili pokrenite ponovo."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-card">
      <h2 className="page-title">Dopuna podataka</h2>
      <p style={{ color: "var(--text-muted, #666)", fontSize: 14, marginTop: -8 }}>
        Preuzima fakture koje nedostaju za izabranu firmu i period. Vec preuzete
        fakture se preskacu.
      </p>
      <form>
        <div className="form-group">
          <label>Ime firme</label>
          <select
            className="form-control"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          >
            {companies.map((company) => (
              <option key={company} value={company}>
                {company}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Od</label>
          <Flatpickr
            className="form-control flatpickr-input"
            value={dateFrom}
            onChange={(date) =>
              setDateFrom(DateTime.fromJSDate(date[0]).toISODate())
            }
            options={{ dateFormat: "Y-m-d" }}
          />
        </div>
        <div className="form-group">
          <label>Do</label>
          <Flatpickr
            className="form-control flatpickr-input"
            value={dateTo}
            onChange={(date) =>
              setDateTo(DateTime.fromJSDate(date[0]).toISODate())
            }
            options={{ dateFormat: "Y-m-d" }}
          />
        </div>
        <div className="form-group">
          <label className="radio-label" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <input
              type="checkbox"
              checked={force}
              onChange={(e) => setForce(e.target.checked)}
            />
            Ponovo preuzmi sve (osveži postojeće fakture)
          </label>
        </div>
        <button
          type="button"
          className="btn-primary"
          onClick={handleBackfill}
          disabled={loading}
        >
          {loading ? (
            "Dopuna u toku..."
          ) : (
            <>
              <FaHistory style={{ marginRight: 8 }} /> Pokreni dopunu
            </>
          )}
        </button>
      </form>
      {message && (
        <div className={`status-message ${isError ? "error" : "success"}`}>
          {message}
        </div>
      )}
    </div>
  );
}

export default BackfillPage;
